import React, { FC, useMemo } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Dropdown,
} from "reactstrap";

import { Down24 } from "@bphxd/ds-core-react/lib/icons";

interface SearchableDropdownProps {
  label: string;
  fieldKey: string;
  options: string[];
  selectedValue?: string;
  searchValue: string;
  placeholder: string;
  isRequired?: boolean;
  error?: string;
  openDropdown: string | null;
  disabled?: boolean;

  onToggle: (field: string) => void;
  onSearchChange: (fieldKey: string, value: string) => void;
  onSelect: (value: string) => void;
}

const SearchableDropdown: FC<SearchableDropdownProps> = ({
  label,
  fieldKey,
  options,
  selectedValue = "",
  searchValue,
  placeholder,
  isRequired = false,
  error,
  openDropdown,
  disabled,
  onToggle,
  onSearchChange,
  onSelect,
}) => {
  const filteredOptions = useMemo(() => {
    return options.filter((option) =>
      String(option).toLowerCase().includes(searchValue.toLowerCase())
    );
  }, [options, searchValue]);

  return (
    <div>
      <Label className="fw-bold mb-2">
        {label}

        {isRequired && (
          <span style={{ color: "red", marginLeft: "4px" }}>
            *
          </span>
        )}
      </Label>

      <Dropdown
        className="w-100"
        isOpen={openDropdown === fieldKey && !disabled}
        toggle={() => !disabled && onToggle(fieldKey)}
      >
        <DropdownToggle
        className="w-100 rounded-0 border d-flex justify-content-between align-items-center"
        color="#fff"
        caret={false}
        disabled={disabled}
        style={{
            padding: "6px 8px",
            backgroundColor: disabled ? "#e9ecef" : "#fff",
        }}
        >
          <span className="text-truncate">
            {selectedValue || placeholder}
          </span>

          <Down24 color={disabled ? "#ccc" : "#007f00"} />
        </DropdownToggle>

        <DropdownMenu className="w-100">
          <div className="p-2">
            <Input
            type="text"
            disabled={disabled}
            placeholder="Type to search..."
            value={searchValue}
            onChange={(e) =>
                onSearchChange(fieldKey, e.target.value)
            }
            onKeyDown={(e) => e.stopPropagation()}
            className="form-control-sm"
            />
          </div>

          {filteredOptions.length > 0 ? (
            <div
              style={{
                maxHeight: "250px",
                overflowY: "auto",
              }}
            >
              {filteredOptions.map((option, index) => (
                <DropdownItem
                  key={`${fieldKey}_${index}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect(option);}
                  }
                >
                  {option}
                </DropdownItem>
              ))}
            </div>
          ) : (
            <DropdownItem
              disabled
              className="text-center p-2"
            >
              No results found
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>

      {error && (
        <small className="text-danger d-block mt-1">
          {error}
        </small>
      )}
    </div>
  );
};

export default React.memo(SearchableDropdown);